import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import Observer from 'react-intersection-observer'

import {
  introImagesSelector,
  companiesWithImagesSelector,
} from '../../redux/selector'

const Thumb = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: rgba(0, 0, 0, 0.1);
`

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  grid-gap: 1rem;
  padding: 2rem;
`

const renderList = x =>
  x.map(({ id, name, images }) => (
    <li key={`company-${id}`} style={{ marginBottom: '4rem' }}>
      <h5>
        {name} ({images.length})
      </h5>
      <Grid>
        {images.map(({ url }) => (
          <Observer key={`image-${url}`}>
            {({ inView, ref }) => (
              <div ref={ref} style={{ paddingTop: '4rem' }}>
                {inView ? (
                  <a href={url} key={url}>
                    <Thumb src={url} alt={url} />
                  </a>
                ) : (
                  <div>Loading...</div>
                )}
              </div>
            )}
          </Observer>
        ))}
      </Grid>
    </li>
  ))

const List = ({ introCompanies, allCompanies }) => {
  return (
    <div>
      <h4>Intro-Layer</h4>
      <ul>{renderList(introCompanies)}</ul>
      <h4>Alle Unternehmen mit Bildern</h4>
      <ul>{renderList(allCompanies)}</ul>
    </div>
  )
}

const mapStateToProps = state => ({
  introCompanies: introImagesSelector(state),
  allCompanies: companiesWithImagesSelector(state),
})

export default connect(mapStateToProps)(List)
